import React from 'react';
import { AssessmentState } from '../types';
import { assessmentData } from '../data/criteria';
import { ProductSelector } from './ProductSelector';
import { CriterionCard } from './CriterionCard';
import { motion } from 'framer-motion';
interface AssessmentFormProps {
  state: AssessmentState;
  onChange: (updates: Partial<AssessmentState>) => void;
  onSubmit: () => void;
}
export function AssessmentForm({
  state,
  onChange,
  onSubmit
}: AssessmentFormProps) {
  const totalCriteria = assessmentData.reduce((acc, comp) => acc + comp.criteria.length, 0);
  const answeredCriteria = Object.keys(state.scores).length;
  const isComplete = state.penilai.trim() !== '' && state.student !== '' && answeredCriteria === totalCriteria;
  const handleScoreSelect = (criterionId: string, score: number) => {
    onChange({
      scores: {
        ...state.scores,
        [criterionId]: score
      }
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.4,
    ease: [0.23, 1, 0.32, 1]
  }} className="max-w-4xl mx-auto px-4 sm:px-6 py-12 pb-32" data-id="element-5">
      {/* Header */}
      <div className="text-center mb-16 space-y-4" data-id="element-6">
        <h1 className="text-3xl md:text-5xl font-bold tracking-tight text-[#1d1d1f] leading-tight" data-id="element-7">
          Penilaian Produk Inovasi
          <br data-id="element-8" />
          <span className="text-[#4F5354]" data-id="element-9">Bimbingan dan Konseling</span>
        </h1>
        <p className="text-[17px] leading-relaxed text-[#86868b] max-w-3xl mx-auto" data-id="element-10">
          Formulir penilaian komprehensif untuk mengevaluasi kualitas,
          kelayakan, dan kebermanfaatan produk inovasi Bimbingan dan Konseling
          berbasis teknologi. Instrumen ini dikembangkan oleh Dr. Dadang
          Sudrajat, M.Pd., MCE., GCE. sebagai acuan penjaminan mutu karya
          inovatif dalam mendukung transformasi digital layanan BK.
        </p>
      </div>

      {/* Identitas Section */}
      <div className="bg-white rounded-3xl p-6 md:p-8 apple-shadow border border-black/[0.02] mb-12" data-id="element-11">
        <h2 className="text-2xl font-semibold text-[#1d1d1f] mb-8" data-id="element-12">
          Identitas Penilaian
        </h2>

        <div className="space-y-8" data-id="element-13">
          <div className="space-y-2" data-id="element-14">
            <label className="block text-sm font-medium text-[#1d1d1f]/70" data-id="element-15">
              Nama Penilai
            </label>
            <input type="text" value={state.penilai} onChange={e => onChange({
            penilai: e.target.value
          })} placeholder="Masukkan nama lengkap Anda" className="w-full bg-white border border-[#d2d2d7] rounded-xl py-3 px-4 text-[15px] text-[#1d1d1f] focus:outline-none focus:ring-2 focus:ring-[#0071e3]/30 focus:border-[#0071e3] transition-all apple-shadow-sm placeholder:text-[#86868b]" data-id="element-16" />
          </div>

          <div className="h-[1px] bg-[#d2d2d7]/50 w-full" data-id="element-17" />

          <ProductSelector state={state} onChange={onChange} data-id="element-18" />
        </div>
      </div>

      {/* Criteria Sections */}
      <div className="space-y-16" data-id="element-19">
        {assessmentData.map((component, idx) => <div key={component.id} className="space-y-6" data-id="element-20">
            <div className="sticky top-0 z-10 apple-glass py-4 px-2 -mx-2 rounded-xl mb-6" data-id="element-21">
              <h2 className="text-xl md:text-2xl font-bold text-[#1d1d1f]" data-id="element-22">
                Komponen {idx + 1}: {component.title}
                <span className="ml-3 text-sm font-medium px-3 py-1 bg-[#f5f5f7] text-[#86868b] rounded-full inline-block align-middle" data-id="element-23">
                  Bobot {component.weight * 100}%
                </span>
              </h2>
            </div>

            <div className="space-y-6" data-id="element-24">
              {component.criteria.map(criterion => <CriterionCard key={criterion.id} criterion={criterion} currentScore={state.scores[criterion.id]} onScoreSelect={score => handleScoreSelect(criterion.id, score)} data-id="element-25" />)}
            </div>
          </div>)}
      </div>

      {/* Submit Action */}
      <div className="mt-16 text-center" data-id="element-26">
        <button onClick={onSubmit} disabled={!isComplete} className={`px-8 py-4 rounded-full text-[17px] font-semibold transition-all duration-300 ${isComplete ? 'bg-[#0071e3] text-white hover:bg-[#0077ed] hover:scale-[1.02] shadow-lg shadow-blue-500/30' : 'bg-[#e5e5ea] text-[#aeaeb2] cursor-not-allowed'}`} data-id="element-27">
          Submit Penilaian
        </button>
        {!isComplete && <p className="text-sm text-[#86868b] mt-4" data-id="element-28">
            Mohon lengkapi identitas dan seluruh {totalCriteria} kriteria
            penilaian sebelum submit.
            <br data-id="element-29" />({answeredCriteria}/{totalCriteria} kriteria terisi)
          </p>}
      </div>
    </motion.div>;
}